import type { FilterConfig } from '#types/config/components/filter'

export default {
  applyButtonVariant: 'primary'
} satisfies FilterConfig['option']['priceInput']
